import Iconify from 'src/components/Iconify';
import { MKT_ANALYTICS_DESIGN as d } from '../MktAnalytics.design';

export default function MetricCard({ icon, iconColor, color, value, label, title, growth, prefix = '', suffix = '' }) {
    const displayLabel = label || title;
    const displayColor = iconColor || color || 'violet';

    const colorMap = {
        violet: { box: d.stats.iconBoxViolet, icon: 'text-violet-600' },
        pink: { box: d.stats.iconBoxPink, icon: 'text-pink-600' },
        rose: { box: d.stats.iconBoxPink, icon: 'text-pink-600' },
        blue: { box: d.stats.iconBoxBlue, icon: 'text-blue-600' },
        green: { box: d.stats.iconBoxGreen, icon: 'text-green-600' },
        amber: { box: d.stats.iconBoxAmber, icon: 'text-amber-600' }
    };

    const colors = colorMap[displayColor] || colorMap.violet;

    const growthNum = parseFloat(growth);
    const growthClass = growthNum > 0
        ? d.stats.growth.positive
        : growthNum < 0
            ? d.stats.growth.negative
            : d.stats.growth.neutral;

    const growthIcon = growthNum > 0
        ? 'eva:trending-up-fill'
        : growthNum < 0
            ? 'eva:trending-down-fill'
            : 'eva:minus-fill';

    const formatValue = (val) => {
        if (typeof val === 'number') {
            if (val >= 1000000) return `${(val / 1000000).toFixed(1)}M`;
            if (val >= 1000) return `${(val / 1000).toFixed(1)}K`;
            return val.toLocaleString('pt-BR');
        }
        return val;
    };

    return (
        <div className={d.stats.card}>
            <div className={`${d.stats.iconBox} ${colors.box}`}>
                <Iconify icon={icon} width={20} className={colors.icon} />
            </div>
            <div>
                <p className={d.stats.value}>{prefix}{formatValue(value)}{suffix}</p>
                <p className={d.stats.label}>{displayLabel}</p>
                {growth !== undefined && growth !== null && (
                    <span className={growthClass}>
                        <Iconify icon={growthIcon} width={14} />
                        {Math.abs(growthNum).toFixed(1)}%
                    </span>
                )}
            </div>
        </div>
    );
}
